import  { useEffect, useState } from 'react';
import './adn40.css';
import NL_vd_bg from '../../../assets/imgs/nuevo_libro/NL_vd_bg.png'
import { useTranslation } from "react-i18next";
const Adn40 = () => {
  const [lang, setLang] = useState(localStorage.getItem('language') || 'es');
    const [langText, setLangText] = useState(lang === 'es' ? 'English' : 'Español');
    const [t, i18n] = useTranslation("librVerd");

  return (
    <div class="NLV_adn40">
        <div class="NLV_adn40_titulo">
            <h2>{(t('adn40.titulo'))}</h2>
        </div>
        <div class="NLV_adn40_video">
            <iframe src="https://www.youtube.com/embed/lkCOG_KN3J0"></iframe>
            <img src={NL_vd_bg} class="NLV_adn40_bg"/>
        </div>
    </div>
  )
}

export default Adn40
